module.exports = __webpack_public_path__ + "img/工作在探见.593eb727.png";